export const getErrorMessage = (error: unknown) => {
  if (error instanceof Error) return error.message;
  return String(error);
};
// We'll use later
// export const reportError = ({ message }: { message: string }) => {
//   // send the error to our logging service...
// };
